module.exports = __webpack_public_path__ + "img/blank_pages.68905ef6.jpg";